import { TenantIncidentTotalsScreen } from "@src/features/patriot-tools";

export default TenantIncidentTotalsScreen;
